import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faLocationCrosshairs } from "@fortawesome/free-solid-svg-icons";
import BaseModel from "../models/BaseModel";

export default function ConsumerMenu(props: { obj: BaseModel }) {
  const { obj } = props;

  function onNavigateTreeview() {
    state.selectionManager.selectedObject = obj;
  }

  return (
    <div
      id="menu basemenu"
      className={"menu"} // no itx
    >
      <div
        id="edit"
        style={{
          width: "max-content",
          height: "20px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          cursor: "pointer",
        }}
      >
        <div
          onClick={() => {
            obj.treeViewModel.handleProperties();
            obj.treeViewModel.unselect();
          }}
        >
          <FontAwesomeIcon icon={faEdit} />
        </div>

        <div
          style={{ marginLeft: "10px" }}
          onClick={() => {
            onNavigateTreeview();
          }}
        >
          <FontAwesomeIcon icon={faLocationCrosshairs} />
        </div>
      </div>
    </div>
  );
}
